import styles from "./ContactCard.module.css";

export default function ContactCard({ title, subtitle, linkLabel }) {
  return (
    <section className={styles.card}>
      <div>
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>
      {linkLabel ? (
        <a className={styles.link} href="#">
          {linkLabel}
        </a>
      ) : null}
    </section>
  );
}
